import { NgModule } from '@angular/core';
import { ProfileService } from './profile.service';
import { TokenAccessorService } from './token.accessor.service';
import { AuthenticationService } from './authentication.service';
import { LoggedInGuard } from './logged-in.guard';

/**
 * `SecurityModule`
 *
 * Authentication module
 */
@NgModule({
    providers: [
        AuthenticationService,
        LoggedInGuard,
        ProfileService,
        TokenAccessorService
    ]
})
export class SecurityModule {
}



// WEBPACK FOOTER //
// ./src/app/services/security/security.module.ts